import { createAsyncThunk } from '@reduxjs/toolkit';

import type {
  CheckEmailCommand,
  CheckEmailResponse,
  SignInCommand,
  SignUpCommand,
  SignUpResponse,
} from '../Domain/repository/AuthRepository';
import type { AuthSession } from '../Domain/entity/AuthTypes';
import { authUseCases } from './authUseCases';

export const signIn = createAsyncThunk<AuthSession, SignInCommand, { rejectValue: string }>(
  'auth/signIn',
  async (command, { rejectWithValue }) => {
    try {
      return await authUseCases.signIn.execute(command);
    } catch (error) {
      return rejectWithValue((error as Error).message ?? '로그인 실패');
    }
  },
);

export const signUp = createAsyncThunk<SignUpResponse, SignUpCommand, { rejectValue: string }>(
  'auth/signUp',
  async (command, { rejectWithValue }) => {
  try {
      return await authUseCases.signUp.execute(command);
  } catch (error) {
      return rejectWithValue((error as Error).message ?? '회원가입 실패');
  }
  },
);

export const checkEmail = createAsyncThunk<CheckEmailResponse, CheckEmailCommand, { rejectValue: string }>(
  'auth/checkEmail',
  async (command, { rejectWithValue }) => {
    try {
      return await authUseCases.checkEmail.execute(command);
    } catch (error) {
      return rejectWithValue((error as Error).message ?? '이메일 중복 확인 실패');
    }
  },
);

